import React from "react";

const HotelBrochurePdf = () => {
  const HotelData = [
    {
      id: 1,
      cover: {
        logo: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6ced36d8-b8ff-4f01-aaa8-c3b572f35a00/public",
        title: "Mansion haus",
        location: "ANJUNA, NORTH GOA",
        tagline: "ZORBA STAYS BOUTIQUE HOTELS",
        website: "www.zorbastays.com",
        mainImage:
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fde6d62a-a746-4b21-8b04-b2acf3dc7f00/public",
      },

      description: {
        title: "The Mansion",
        mainImage:
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/63e5f73c-8443-4ca1-08d3-74e6b0f39800/public",
        content: [
          "Set in the vibrant heart of Goa, MansionHaus is a luxury boutique retreat featuring nine exquisitely designed suites. Seamlessly blending tranquility with contemporary flair, it offers a serene sanctuary for the discerning traveler. Originally a 19th-century private residence, MansionHaus has been meticulously restored into a sophisticated haven where old-world charm meets modern elegance. Available for exclusive hire, this luxurious residence provides an intimate and bespoke experience, perfect for those seeking privacy and indulgence.",
          "From savoring gourmet delicacies to soaking up the Goan sunshine or exploring the region's rich cultural tapestry, every moment at MansionHaus is crafted to deliver an unforgettable experience of elegance, comfort, and authenticity. From savoring gourmet delicacies to soaking up the Goan sunshine or exploring the region's rich cultural tapestry, every moment at MansionHaus is crafted to deliver an unforgettable experience of elegance, comfort, and authenticity.",
        ],
      },

      gallery: {
        logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",
        images: [
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e7abed20-9c1c-401f-2c47-8d8d1cd61200/public",
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3738c819-c730-4a6d-c6ef-a7feace64f00/public",
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fde6d62a-a746-4b21-8b04-b2acf3dc7f00/public",
        ],
      },

      amenities: {
        title: "Inclusions & Amenities",
        items: [
          {
            label: "PRIVATE POOL",
            icon: "https://cdn-icons-png.flaticon.com/512/3144/3144585.png",
          },
          {
            label: "BAR",
            icon: "https://cdn-icons-png.flaticon.com/512/920/920605.png",
          },
          {
            label: "SCENIC VIEWS",
            icon: "https://cdn-icons-png.flaticon.com/512/2509/2509730.png",
          },
          {
            label: "JACUZZI",
            icon: "https://cdn-icons-png.flaticon.com/512/10307/10307901.png",
          },
          {
            label: "PROPERTY MANAGER",
            icon: "https://cdn-icons-png.flaticon.com/512/1057/1057231.png",
          },
          {
            label: "CATERING SERVICES",
            icon: "https://cdn-icons-png.flaticon.com/512/3050/3050212.png",
          },
          {
            label: "POWER BACKUP",
            icon: "https://cdn-icons-png.flaticon.com/512/2996/2996650.png",
          },
          {
            label: "WI-FI",
            icon: "https://cdn-icons-png.flaticon.com/512/93/93158.png",
          },
          {
            label: "ENTERTAINMENT AND RECREATIONAL AREA",
            icon: "https://cdn-icons-png.flaticon.com/512/3163/3163478.png",
          },
          {
            label: "GARDENS AND OUTDOOR SPACES",
            icon: "https://cdn-icons-png.flaticon.com/512/628/628283.png",
          },
          {
            label: "KITCHEN ESSENTIALS",
            icon: "https://cdn-icons-png.flaticon.com/512/1698/1698691.png",
          },
          {
            label: "EVENING TURNDOWN SERVICE",
            icon: "https://cdn-icons-png.flaticon.com/512/3094/3094404.png",
          },
        ],
      },

      living: {
        title: "LIVING AREA",
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/45c43603-3ab5-4e13-c15b-7edc4ae67b00/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d298aff3-ceb9-47fe-4c30-71850bace000/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/76df6914-ece9-4497-f7e0-5e7174d13400/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/9f645133-4722-46fe-2892-76accacdc000/public",
        ],
      },

      kitchen: {
        title: "KITCHEN & DINING",
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6c5b0f13-70d9-4331-0f2b-69233a252000/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/a7017f2a-b9fc-4ba4-6838-cf256f74dc00/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/557d4a3f-1253-4ece-cbc7-06ba225d6100/public",
        ],
      },

      bedroom: {
        mainImage:
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6c5b0f13-70d9-4331-0f2b-69233a252000/public",
      },

      rooms: {
        title: "ROOMS & BATHS",
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/832c2877-d735-4592-8252-3afb00779400/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/87ab030d-06f3-4cf2-1831-dc1e03423100/public",
        ],
      },

      suites: {
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e4063648-4061-431e-a89a-687f716c4200/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1a33cf91-b733-471d-63d3-eee2eb984d00/public",
        ],
      },

      image3: {
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5fe6f204-6863-4b13-796a-5121233ee500/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d2208260-baf9-47bd-f955-744d2e0eb300/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/ebff03a9-f1b4-4370-72ae-ff0214617100/public",
        ],
      },

      image2: {
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1105b3ca-3c3f-454a-c962-c6b409e5ac00/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f1ca2021-0bb3-4409-7b74-3d535b157a00/public",
        ],
      },

      images2: {
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/23858ec0-52d3-4543-9a76-fb591c160000/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d298aff3-ceb9-47fe-4c30-71850bace000/public",
        ],
      },

      commonArea: {
        title: "COMMON AREA",
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/de4f7f7f-4457-4948-679c-c9761d133000/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1dd600b8-ba2a-4f64-6f53-440e3db4a000/public",
        ],
      },

      commonArea1: {
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/7d176ed5-f25b-4148-297d-63c8a4af8e00/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/76df6914-ece9-4497-f7e0-5e7174d13400/public",
        ],
      },

      commonArea2: {
        images: [
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/fee8e210-1481-4383-b542-6fdb3bb22600/public",
          "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/cce0bb6a-a6f4-42d0-d58b-bfaa69bd7700/public",
        ],
      },

      about: {
        title: "About Zorba",
        tagline: "Find your self in nature.",
        content: [
          "Zorba was born from the slow realization that everyone we've assisted or known over the years, have all wanted very different kinds of travel experiences. But even with all the differences, what anchored them together was the singular belief in the human & nature connection, a belief that there can be very few pleasures as universal and as pure as the simple feeling of sand between your toes on a beach or the sensation of walking barefoot on fresh green grass.",
          "This has become our attempt with Zorba Stays, to assist people in having an honest beautiful experience that they've always wanted.",
          "Zorba Stays is our hope to assist people in exploring the beautiful landscapes of our country, from the warm beaches of Goa to the serene valleys of Uttarakhand and beyond. Whether someone is looking for meditation or a collective celebration - a marriage or a party, we want to invite everyone, as long as they're seeking an honest, beautiful experience. Come explore with us and realize this dream together at Zorba Stays.",
        ],
      },

      closing: {
        logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
        website: "www.zorbastays.com",
        email: "info@zorbastays.com",
        phone: "63552-31066, 98750-28066",
      },
    },
  ];

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size),
    );
  };

  const Property = HotelData[0];

  return (
    <div className="bg-[#F8F9FA] min-h-screen flex flex-col items-center py-6 print:bg-[#FDFDFD] print:p-0">
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display&family=Montserrat&display=swap');
          @page { size: A4; margin: 0; }
          body { margin: 0; padding: 0; }
          .a4-container { width: 210mm; height: 297mm; background: white; display: block; margin: 0 auto; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1); }
          @media screen { .a4-container { transform: scale(0.98); transform-origin: top center; margin-bottom: 20px; } }
          @media print { .a4-container { transform: scale(1); page-break-after: always; break-after: page; margin: 0; box-shadow: none !important; } }
          .playfair { font-family: 'Playfair Display', serif; }
          .montserrat { font-family: 'Montserrat', sans-serif; }
        `,
        }}
      />
      {/* page 1 */}
      <div className="a4-container relative overflow-hidden print:shadow-none">
        <div className="relative h-full w-full flex flex-col items-center px-16 pt-24 pb-12">
          <div className="absolute top-0 left-12 flex gap-6 h-full">
            <div className="h-[270px] border-l-2 border-gray-400"></div>
            <div className="h-[200px] border-l-2 border-gray-400"></div>
            <div className="h-[150px] border-l-2 border-gray-400"></div>
          </div>

          <div className="absolute top-6 right-6">
            <img src={Property.cover.logo} alt="Logo" className="h-32" />
          </div>

          <div className="mt-auto text-center">
            <h1 className="text-5xl playfair lowercase first-letter:uppercase">
              {Property.cover.title}
            </h1>
            <p className="montserrat tracking-[0.1em] text-sm font-medium mt-3">
              {Property.cover.location}
            </p>
          </div>

          <div className="flex justify-center mt-16">
            <img
              src={Property.cover.mainImage}
              alt="Hotel"
              className="w-[600px] h-[600px] object-cover"
            />
          </div>

          <div className="mt-6">
            <p className="montserrat tracking-[0.2em] text-[11px]">
              {Property.cover.website}
            </p>
          </div>
        </div>
      </div>

      {/* page 2 */}
      <div className="a4-container relative overflow-hidden print:shadow-none">
        <div className="h-full w-full flex flex-col px-20 pt-20">
          <div className="w-full flex justify-center mb-12">
            <img
              src={Property.description.mainImage}
              alt="Mansion View"
              className="w-full h-[500px] object-cover "
            />
          </div>

          <div className="flex flex-col text-left max-w-2xl">
            <h2 className="text-4xl playfair text-slate-800 mb-6">
              {Property.description.title}
            </h2>

            {Property.description.content.map((para, index) => (
              <p
                key={index}
                className="montserrat text-[15px] leading-relaxed text-gray-700 mb-5 font-light"
              >
                {para}
              </p>
            ))}
          </div>
        </div>
      </div>

      {/* page 3 */}
      <div className="a4-container relative overflow-hidden print:shadow-none">
        <div className="h-full w-full flex flex-col items-center px-12 py-16">
          <div className="grid grid-cols-2 gap-4 w-full h-[85%]">
            <div className="h-[450px]">
              <img
                src={Property.gallery.images[0]}
                alt="Gallery 1"
                className="w-full h-full object-cover "
              />
            </div>

            <div className="h-[450px]">
              <img
                src={Property.gallery.images[1]}
                alt="Gallery 2"
                className="w-full h-full object-cover "
              />
            </div>

            <div className="col-span-2 h-[350px] mt-2">
              <img
                src={Property.gallery.images[2]}
                alt="Gallery 3"
                className="w-[450px] h-full object-cover "
              />
            </div>
          </div>

          <div className="mt-auto mb-0 flex items-center gap-4 w-full justify-center">
            <div className="w-12 border-t-2 border-gray-400"></div>
            <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
              <img
                src={Property.gallery.logo}
                alt={Property.description.title}
                className="w-8 h-5 brightness-0"
              />
            </div>
            <div className="w-12 border-t-2 border-gray-400"></div>
          </div>
        </div>
      </div>

      {/* page 4 */}
      {chunkArray(Property.amenities.items, 15).map((chunk, chunkIdx) => (
        <div
          key={chunkIdx}
          className="a4-container relative overflow-hidden print:shadow-none"
        >
          <div className="h-full w-full flex flex-col px-20 pt-24">
            {chunkIdx === 0 && (
              <h2 className="text-4xl playfair mb-20">
                {Property.amenities.title}
              </h2>
            )}

            <div
              className={`grid grid-cols-3 gap-y-16 gap-x-12 ${chunkIdx > 0 ? "pt-12" : ""}`}
            >
              {chunk.map((item, idx) => (
                <div
                  key={idx}
                  className="flex flex-col items-center text-center"
                >
                  <div className="w-16 h-16 mb-4 flex items-center justify-center">
                    <img
                      src={item.icon}
                      alt={item.label}
                      className="w-12 h-12 object-contain opacity-70 grayscale contrast-125"
                    />
                  </div>

                  <p className="montserrat text-[10px] tracking-[0.2em] font-medium leading-tight max-w-[140px]">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}

      {/* page 5 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="mb-4 flex justify-end">
            <span className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em]">
              {Property.living.title}
            </span>
          </div>

          <div className="grid h-full grid-cols-2 grid-rows-[auto_1fr] gap-4">
            <div className="col-span-2 h-[450px]">
              <img
                src={Property.living.images[0]}
                alt="Living Area Main"
                className="h-full w-full object-cover "
              />
            </div>

            <div className="flex flex-col gap-2">
              <div className="h-[230px] w-[430px]">
                <img
                  src={Property.living.images[1]}
                  alt="Living Area Top View"
                  className="h-full w-full object-cover "
                />
              </div>
              <div className="h-[230px] w-[430px]">
                <img
                  src={Property.living.images[2]}
                  alt="Living Area Detail"
                  className="h-full w-full object-cover "
                />
              </div>
            </div>

            <div className="h-[350px] w-[230px] ml-24">
              <img
                src={Property.living.images[3]}
                alt="Living Area Perspective"
                className="h-full w-full object-cover "
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 6 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="mt-5 mb-3 flex justify-start">
            <span className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-800">
              {Property.kitchen.title}
            </span>
          </div>

          <div className="flex flex-col h-full gap-4">
            <div className="w-full h-[450px]">
              <img
                src={Property.kitchen.images[0]}
                alt="Kitchen"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="grid grid-cols-2 gap-4 h-[440px]">
              <div className="h-full w-full">
                <img
                  src={Property.kitchen.images[1]}
                  alt="Dining View 1"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="h-full w-full">
                <img
                  src={Property.kitchen.images[2]}
                  alt="Dining View 2"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* page 7 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="h-full w-full flex flex-col p-0">
          <div className="flex-1 w-full overflow-hidden">
            <img
              src={Property.bedroom.mainImage}
              alt="Bedroom Suite"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* page 8 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="mt-5 mb-3 flex justify-start">
            <span className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-800">
              {Property.rooms.title}
            </span>
          </div>

          <div className="flex flex-col h-full gap-4">
            <div className="w-full h-[450px]">
              <img
                src={Property.rooms.images[0]}
                alt="Luxury Suite Top"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="w-full h-[440px]">
              <img
                src={Property.rooms.images[1]}
                alt="Luxury Suite Perspective"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 9 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="flex flex-col h-full gap-8 mt-10">
            <div className="w-full h-[450px]">
              <img
                src={Property.suites.images[0]}
                alt="Luxury Suite View 1"
                className="h-full w-full object-cover shadow-sm"
              />
            </div>

            <div className="flex justify-end w-full">
              <div className="w-[75%] h-[400px]">
                <img
                  src={Property.suites.images[1]}
                  alt="Luxury Suite View 2"
                  className="h-full w-full object-cover shadow-md"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* page 10 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="flex flex-col h-full gap-4 mt-10">
            <div className="w-full h-[450px]">
              <img
                src={Property.image3.images[0]}
                alt="Kitchen"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="flex gap-4 h-[440px]">
              <div className="w-[40%] h-full">
                <img
                  src={Property.image3.images[1]}
                  alt="Dining View 1"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="w-[60%] h-full flex items-start">
                <div className="w-full h-[60%]">
                  <img
                    src={Property.image3.images[2]}
                    alt="Dining View 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* page 11 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="flex flex-col h-full gap-4 mt-10">
            <div className="w-full h-[450px]">
              <img
                src={Property.image2.images[0]}
                alt="Luxury Suite Top"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="w-full h-[440px]">
              <img
                src={Property.image2.images[1]}
                alt="Luxury Suite Perspective"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 12 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="flex flex-col h-full gap-4 mt-10">
            <div className="w-full h-[450px]">
              <img
                src={Property.images2.images[0]}
                alt="Luxury Suite Top"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="w-full h-[440px]">
              <img
                src={Property.images2.images[1]}
                alt="Luxury Suite Perspective"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 13 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="mb-3 flex justify-start">
            <span className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-800">
              {Property.commonArea.title}
            </span>
          </div>

          <div className="flex flex-col h-full gap-6">
            <div className="w-full h-[550px]">
              <img
                src={Property.commonArea.images[0]}
                alt="Common Area Library"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="w-[350px] h-[320px]">
              <img
                src={Property.commonArea.images[1]}
                alt="Common Area Meeting"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 14 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="flex flex-col h-full gap-4 mt-10">
            <div className="w-full h-[450px]">
              <img
                src={Property.commonArea1.images[0]}
                alt="Luxury Suite Top"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="w-full h-[440px]">
              <img
                src={Property.commonArea1.images[1]}
                alt="Luxury Suite Perspective"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 15 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col p-16">
          <div className="flex flex-col h-full gap-4 mt-10">
            <div className="w-full h-[450px]">
              <img
                src={Property.commonArea2.images[0]}
                alt="Luxury Suite Top"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="w-full h-[440px]">
              <img
                src={Property.commonArea2.images[1]}
                alt="Luxury Suite Perspective"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* page 16 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col px-20 pt-24">
          <div className="mb-40">
            <h2 className="text-4xl playfair ">{Property.about.title}</h2>
          </div>

          <div className="flex justify-end w-full">
            <div className="max-w-sm">
              <h3 className="italic playfair text-2xl mb-8">
                {Property.about.tagline}
              </h3>

              {Property.about.content.map((para, index) => (
                <p
                  key={index}
                  className="montserrat text-[15px] leading-relaxed  mb-6 text-justify"
                >
                  {para}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* page 17 */}
      <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
        <div className="flex h-full w-full flex-col items-center justify-center relative px-16">
          <div className="flex flex-col items-center justify-center">
            <img
              src={Property.closing.logo}
              alt="Zorba Logo"
              className="w-[40%] brightness-0"
            />
          </div>

          <div className="absolute bottom-6 w-full text-center">
            <p className="montserrat text-[10px] tracking-[0.2em]">
              {Property.closing.website} | {Property.closing.email} |{" "}
              {Property.closing.phone}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelBrochurePdf;
